module.exports = __webpack_public_path__ + "static/media/06_4.8e08769a.png";